import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
} from "components/misc/Headings.js";
import {
  Container as ContainerBase,
  ContentWithPaddingXl,
} from "components/misc/Layouts";
import { SectionDescription } from "components/misc/Typography";

const Container = tw(
  ContainerBase
)`my-8 lg:my-10 bg-primary-900 text-gray-100 -mx-8 px-8`;
const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)`sm:text-3xl md:text-4xl lg:text-2xl`;

const Description = tw(
  SectionDescription
)`text-gray-400 text-center mx-auto max-w-screen-md`;

const StatsContainer = tw.div`mt-8 flex flex-col sm:flex-row items-center justify-center flex-wrap max-w-screen-md justify-between mx-auto`;
const Stat = tw.div`flex flex-col text-center p-4 tracking-wide`;
const StatKey = tw.div`text-xl font-medium`;
const StatValue = tw.div`text-4xl sm:text-3xl md:text-4xl lg:text-5xl font-black`;

export default ({
  heading = "Research shows that children with disabilities are more likely to be sexually abused than children without disabilities. (Barnard-Brak et al., 2014; Grove et al., 2018)",
  description = "In particular, a study conducted in the UK on the relationship between disability and child maltreatment found that children with disabilities are around 3-4 times more frequently/likely to be sexually abused than their peers without disabilities (Jones, 2012).",
  heading2 = "Factors",
  stats = [
    {
      key: "Social Isolation",
      value: "1",
    },
    {
      key: "Communication Barriers",
      value: "2",
    },
    {
      key: "Dependence On Caregivers",
      value: "3",
    },
  ],
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          <Heading>{heading}</Heading>
          {description && <Description>{description}</Description>}
          <br />
          <br />
          <br />
          {heading2 && <Heading>{heading2}</Heading>}
        </HeadingContainer>
        <StatsContainer>
          {stats.map((stat, index) => (
            <Stat key={index}>
              <StatValue>{stat.value}</StatValue>
              <StatKey>{stat.key}</StatKey>
            </Stat>
          ))}
        </StatsContainer>
      </ContentWithPaddingXl>
    </Container>
  );
};
